import { Modal } from 'antd'
import styled from 'styled-components'

export const ContainerPontosColeta = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 15px;
  padding: 15px;

  .map__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    gap: 10px;
    background: rgba(0, 0, 0, 0.47);
    backdrop-filter: blur(2px);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: white;
    font-size: 16px;
    font-weight: 600;
    border-radius: 8px;
    z-index: 10;
    text-align: center;
    padding: 20px;
  }
`

export const ControleLateral = styled.div`
  width: 25%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  gap: 10px;
`

export const CardFlutuanteAlteracoes = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  background-color: white;
  padding: 12px 15px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 5;
`

export const CardFlutuanteInfo = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  left: 15px;
  height: 50px;
  background-color: white;
  padding: 0 15px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 5;
  
  div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      label {
        font-size: 11px;
        font-weight: 500;
        color: #7b7b7b;
        padding: 0;
        margin: 0;
      }

      p {
        padding: 0;
        margin: 0;
        line-height: 1.1;
        font-size: 13px;
        font-weight: 600;
      }
    }
`

export const OverlayFullscreen = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1050;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ContainerFullscreen = styled.div`
  background-color: #fff;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
`

export const WrapperMapaFullscreen = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  position: relative;
`

export const SidebarContainerFullscreen = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  width: 380px;
  /* height removed to respect top/bottom */
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  z-index: 5;
  overflow: hidden;
`

export const SidebarTopBar = styled.div`
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  gap: 10px;
`

export const SidebarHeader = styled.div`
  padding: 15px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;

  .info__item {
    display: flex;
    flex-direction: column;
    align-items: center;

    label {
      font-size: 11px;
      font-weight: 500;
      color: #7b7b7b;
      margin: 0;
    }

    p {
      margin: 0;
      line-height: 1.2;
      font-size: 13px;
      font-weight: 600;
    }
  }
`

export const SidebarAlterations = styled.div`
  padding: 10px 15px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;

  label {
    font-size: 12px;
    fontWeight: 700;
    color: #7b7b7b;
    margin: 0;
  }
`

export const SidebarContent = styled.div`
  display: flex;
  flex: 1; /* Make it expand */
  flex-direction: column;
  gap: 5px;
  overflow-y: auto;
  padding: 15px;
  position: relative;
`

export const SidebarFooter = styled.div`
  width: 100%;
  padding: 15px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  gap: 10px;
  justify-content: flex-start;
`


export const ModalMalhaGeral = styled(Modal)`
  height: 100vh;
  .ant-modal-content {
    border-radius: 8px;
    padding: 0px;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .ant-modal-body {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .ant-modal-header {
    margin: 0;
  }

  .ant-modal-footer{
    margin-top: 0px;
  }

  .title {
    display: flex;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 16px;
    justify-content: space-between;
    align-items: center;
    

    h3 {
      font-size: 17px;
      font-weight: 600;
      margin: 0;
      padding: 0;
    }
  }

  .modal_infos {
    display: flex;
    height: 30px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-left: 15px;
    padding-right: 15px;

    div {
      display: flex;
      height: 50px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 15px;

      label {
        font-size: 12px;
        font-weight: 500;
        color: #7b7b7b;
        padding: 0;
        margin: 0;
      }

      p {
        padding: 0;
        margin: 0;
        line-height: 1.1;
        font-size: 13px;
        font-weight: 600;
      }
    }
  }
`

export const ContainerPontosAdicionados = styled.div`
  width: 100%;
  height: 100%;

  .ant-collapse-content-box {
    padding: 10px !important;
  }

  .container__adicionados {
    width: 100%;
    display: flex;
    flex-direction: column;
    border: 2px solid #d9d9d9;
    padding: 10px;
    border-radius: 8px;
    gap: 5px;
  }

  .header__adicionados {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .nome__analise {
      padding: 7px;
      font-size: 11px;
      font-weight: 700;
      color: white;
      border-radius: 5px;
    }
  }

  .points-title {
    color: #757575;
    font-size: 12px;
    font-weight: 700;
    margin: 0;
    padding: 0;
  }

  .points-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .point-card {
    background-color: var(--cor-do-item);
    color: white;
    border: 2px solid var(--cor-do-item);
    font-weight: 700;
    font-size: 12px;
    width: 30px !important;
    height: 30px;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
  }

  .point-card:hover {
    transition: 0.5s;
    transform: scale(1.05);
    background-color: var(--cor-do-item);
    border: 2px solid var(--cor-do-item);
    color: white;
  }
`
